export default "__VITE_ASSET__CgegA2HL__"